import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import * as Actions from '../redux/categoryActions';
import * as Selectors from '../redux/categorySelectors';
import CategoryForm from '../form/CategoryForm';
import { CategoryValues, CategoryParams, CategoryGetResponse } from '../model/categoryModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import * as CategorySelectors from '../redux/categorySelectors';
import * as CommonSelectors from '../../../shared/redux/commonSelectors';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { objectHelper } from '../../../shared/utils/objectHelper';
import { CATEGORY_ID } from '../enums/categoryId';

const getCategoryValue = (categoriesTree: CategoryGetResponse[], params: CategoryParams, index: number) => {
  const category = categoriesTree[index];

  if (category && Number(category.id) !== Number(params.id)) {
    return {
      value: category.name,
      key: category.iri,
    };
  }

  return {
    value: '',
    key: '',
  };
};

const breadcrumbs = [
  {
    label: 'category.edit',
    to: null,
  },
];

let disableSuccessSnackbarAction = true;

const CategoryEdit: React.FC = () => {
  const params = useParams<CategoryParams>();
  const dispatch = useDispatch();
  const initialValues = useSelector(Selectors.initialValues);
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiCategoryRequestState);
  const apiRequestError = useSelector(Selectors.apiCategoryRequestError);
  const categoriesTree = useSelector(CategorySelectors.categoriesTree);
  const rootCategory = useSelector(CommonSelectors.rootCategory);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    if (initialValues.name.length && categoriesTree.length && apiRequestState !== API_REQUEST_STATE.LOADING) {
      hide();
    }
  }, [initialValues, categoriesTree]);

  useEffect(() => {
    if (params.id === CATEGORY_ID.ROOT) {
      history.push(ROUTES.CATEGORY.LIST);
    } else {
      dispatch(Actions.getCategory(params));
      dispatch(Actions.getCategoriesTree(params));
    }
  }, [params]);

  useEffect(
    () => () => {
      dispatch(Actions.resetCategory());
    },
    [],
  );

  return (
    <>
      <SnackbarSettings
        disableSuccessAction={disableSuccessSnackbarAction}
        successMessage="category.snackbar.edit_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiCategoryRequestState}
        onSuccess={() => {
          history.push(ROUTES.CATEGORY.LIST);
        }}
      />
      <CategoryForm
        parentId={rootCategory ? (rootCategory.value as unknown as number) : undefined}
        categoryId={parseInt(params.id!)}
        breadcrumbs={breadcrumbs}
        title="category.edit"
        initialValues={{
          ...initialValues,
          categoryOne: getCategoryValue(categoriesTree, params, 0),
          categoryTwo: getCategoryValue(categoriesTree, params, 1),
        }}
        isRootCategory={parseInt(params.id!) === rootCategory?.value}
        isMainCategory={parseInt(params.id!) !== rootCategory?.value && categoriesTree.length === 1}
        onSubmit={(values: CategoryValues) => {
          show();
          disableSuccessSnackbarAction = false;
          dispatch(
            Actions.editCategory(
              params,
              objectHelper.removeByKeys<CategoryValues>(['categoryOne', 'categoryTwo'], {
                ...values,
                image: values.image || null,
                parent: values.categoryTwo.key
                  ? values.categoryTwo.key
                  : values.categoryOne.key
                  ? values.categoryOne.key
                  : rootCategory?.iri!,
              }),
            ),
          );
        }}
      />
    </>
  );
};

export default CategoryEdit;
